import { render, staticRenderFns } from "./RestrictionLock.vue?vue&type=template&id=7fa72d9e"
import script from "./RestrictionLock.vue?vue&type=script&lang=js"
export * from "./RestrictionLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports